import type { AsyncBelongsTo, AsyncHasMany } from '@ember-data/model';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import type VisitCompositeModel from './visit-composite';

export default class VisitorProfileModel extends Model {
  @hasMany('visit-composite', { async: true, inverse: 'visitorProfile' })
  declare visits: AsyncHasMany<VisitCompositeModel>;

  @belongsTo('visit-composite', { async: true, inverse: null })
  declare relevantVisit: AsyncBelongsTo<VisitCompositeModel>;

  // use if relevantVisit is pre-loaded
  get relevantVisitSync(): VisitCompositeModel | null {
    return this.relevantVisit.content || null;
  }

  @attr('string') declare displayName: string;
  @attr('string') declare primaryEmail: string | null;
  @attr('string') declare primaryPhoneNumber: string | null;
  @attr('string') declare photoUrl: string | null;

  get formattedPhoneNumber(): string {
    const phoneNumber = this.primaryPhoneNumber;

    if (!phoneNumber) {
      return '';
    }

    const parsed = parsePhoneNumberFromString(phoneNumber);
    return parsed?.formatInternational() || phoneNumber;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'visitor-profile': VisitorProfileModel;
  }
}
